(() => {
	const siteName = 'stanley-electric';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 80,
				sp: 50
			}
		},
		localDecision() {
			let regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|test6\\.sh-create\\.co\\.jp|localhost|192\\.168\\.|rp-stanley-pro\\.prj\\.connecty\\.net|api\\.stanley-electric\\.com)`, 'g');
			// RoHS指令適合証明書ダウンロードフォーム用の設定
			if(FUNCTIONS.va.pathname.includes('/products/support/dl_rohs_certificate/')) {
				regExp = new RegExp(`(stanley-electric\\.com|stanley-electric\\.cn)`, 'g');
			}
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				
				// RoHS指令適合証明書ダウンロードフォーム　stanley-electric.cn用の設定
				if(window.location.hostname === 'www.stanley-electric.cn' && FUNCTIONS.va.pathname.includes('/products/support/dl_rohs_certificate/')) {
					let classArray = ele.classList;
					let incClass = '';
					classArray.forEach(className => {
						if(className.startsWith('inc_')) {
							incClass = className;
						}
					})
					path = '/common/include/'+ incClass;
				}

				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			let $subTab = document.querySelectorAll('.js-tab.js-tabSub');

			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				// メインタブ切り替えの処理
				$tab.forEach(tab => {
					let $parent = tab.closest('.mod-tab03');
					let $tabWrap = tab.closest('.js-tabWrap');

					tab.addEventListener('click', function () {
						// .js-tabSub クラスを持つタブは無視
						if (this.classList.contains('js-tabSub')) return;

						// クリックされたメインタブの data-target を取得
						const target = this.getAttribute('data-target');

						// メインタブのコンテンツを切り替え
						// ページ内にタブが複数設置されている場合
						if($tabWrap) {
							$content = $tabWrap.querySelectorAll('.js-tab-content');
						}
						$content.forEach(content => {
							if (content.getAttribute('data-target') === target) {
								content.classList.add('is-active', 'is-visible');
							} else {
								content.classList.remove('is-active', 'is-visible');
							}
						});

						// メインタブのボタンを切り替え
						if($parent) {
							$parent.querySelectorAll('.js-tab').forEach(tab => {
								tab.classList.remove('is-active');
							});
						} else {
							$tab.forEach(tab => {
								tab.classList.remove('is-active');
							});
						}
						
						this.classList.add('is-active');

						// サブタブの初期状態を設定（最初のサブタブがアクティブに）
						const firstSubTab = document.querySelector(`.js-tab-content[data-target="${target}"] .js-tabSub`);
						if (firstSubTab) {
							firstSubTab.click();
						}
					});
				});

				// サブタブ切り替えの処理
				$subTab.forEach(tab => {
					tab.addEventListener('click', function () {
						// クリックされたサブタブの data-target を取得
						const target = this.getAttribute('data-target');

						// サブタブのコンテンツを切り替え
						const parentContent = this.closest('.js-tab-content'); // 親コンテンツを取得
						parentContent.querySelectorAll('.js-tabSub').forEach(subTab => {
							subTab.classList.remove('is-active');
						});
						this.classList.add('is-active');

						parentContent.querySelectorAll('.js-tab-content.js-tabSub').forEach(content => {
							if (content.getAttribute('data-target') === target) {
								content.classList.add('is-active', 'is-visible');
							} else {
								content.classList.remove('is-active', 'is-visible');
							}
						});
					});
				});

			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
			  return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
				  resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(function () {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			  });
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				let footerPos = footer.offsetTop;
				let stopPos = footerPos - window.innerHeight;
				

				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
						$pagetop.classList.add(f);
					} else {
						$pagetop.classList.remove(v);
						$pagetop.classList.remove(f);
					}

					if (window.scrollY >= stopPos) { // ページTOPの位置を固定
						$pagetop.classList.add('is-absolute');
					} else {
						$pagetop.classList.remove('is-absolute');
					}
				});
			}
		},
		setModal() {
			const positionCloseButton = (_container) => {
				let contentRect = _container.querySelector('img').getBoundingClientRect();
				let $closeBtn = _container.querySelector('.mod-modal-closeBtn');
				$closeBtn.style.top = `${contentRect.top - $closeBtn.offsetHeight}px`;
				if (FUNCTIONS.va.window.width < 769) {
					$closeBtn.style.right = `${FUNCTIONS.va.window.width - contentRect.right}px`;
				} else {
					$closeBtn.style.right = `${FUNCTIONS.va.window.width - contentRect.right - $closeBtn.offsetWidth / 2}px`;
				}
			};
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);

				// 画像モーダルの場合、幅/高さを取得してcloseボタンの位置を調整
				if (!$container.querySelector('.mod-modalContent') && $container.querySelector('img')) {
					$container.querySelector('img').addEventListener('load', () => {
						positionCloseButton($container);
						window.addEventListener('resize', () => { positionCloseButton($container); });
					});
				}

				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};

			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		headerHamburger() {
			const $hamburger = document.querySelector('.header-hamburger');
			const $nav = document.querySelector('.header-nav');
			const $container = document.querySelector('.container');
			let scrollTopNow;

			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = (-1 * scrollTopNow) + 'px';
				$container.style.left = 0;
				document.body.classList.add(f);
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo({ top: scrollTopNow });
			};

			if ($hamburger) {
				$hamburger.addEventListener('click', (e) => {
					e.currentTarget.classList.toggle(a);
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(v);
						$nav.classList.remove(a);
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						setTimeout(() => { $nav.classList.add(v); });
					}

					// 下層メニューを全て閉じる
					let activeBtn = document.querySelectorAll('.js-megaMenu-btn.is-active');
					let activeBlock = document.querySelectorAll('.js-megaMenu-block.is-active');
					let activeSubBtn = document.querySelectorAll('.js-subMenu-btn.is-active');
					let activeSubBlock = document.querySelectorAll('.js-subMenu-block.is-active');
					if (activeBtn.length) {
						activeBtn[0].classList.remove(a);
					}
					if (activeBlock.length) {
						activeBlock[0].classList.remove(a);
					}
					if (activeSubBtn.length) {
						activeSubBtn[0].classList.remove(a);
					}
					if (activeSubBlock.length) {
						activeSubBlock[0].classList.remove(a);
					}
				});
			}

			// メニューの高さ設定
			function setVh() {
				let vh = window.innerHeight * 0.01; // ビューポートの高さの1%
				document.documentElement.style.setProperty('--vh', `${vh}px`);
			}
		
			window.addEventListener('resize', setVh);
			window.addEventListener('load', setVh);
		},
		headerScroll() {
			let header = document.querySelector('.header');
			let timer, flag;

			let set_position = 0;
			window.addEventListener('scroll', function () {
				let thisScroll = document.documentElement.scrollTop;

				if (thisScroll === 0 && flag) {
					header.classList.remove('is-on');
					flag = false;
				} else if (thisScroll > 0 && !flag) {
					header.classList.add('is-on');
					flag = true;
				}

				set_position = thisScroll;
			});
		},
		headerMenu() {
			// カレント
			document.querySelectorAll('.js-megaMenu-btn').forEach((ele) => {
				let $href = ele.getAttribute('href');
				if (FUNCTIONS.va.pathname.startsWith($href)) {
					ele.classList.add('is-current');
				}
			});

			// 各製作所用ヘッダー カレント
			const worksItems = document.querySelectorAll('.js-works-item');
			if(worksItems.length) {
				worksItems.forEach(ele => {
					let $href = ele.getAttribute('href');
					if(FUNCTIONS.va.pathname.startsWith($href)) {
						ele.classList.add('is-current');
					}
				});
			}

			// サイト内検索
			const headerSearch = document.querySelector('.js-siteSearch');
			const headerSearchBlock = document.querySelector('.js-siteSearch-block');
			const headerLanguage = document.querySelector('.js-changeLang');
			const headerLanguageBlock = document.querySelector('.js-changeLang-block')
			if(headerSearch) {
				headerSearch.addEventListener('click', (e) => {
					headerSearch.classList.toggle(a);
					headerSearchBlock.classList.toggle(a);
					if(headerLanguage.classList.contains(a)) {
						headerLanguage.classList.remove(a);
						headerLanguageBlock.classList.remove(a);
					}
				});
			}
			// 言語メニュー
			if(headerLanguage) {
				headerLanguage.addEventListener('click', (e) => {
					headerLanguage.classList.toggle(a);
					headerLanguageBlock.classList.toggle(a);
					if(headerSearch.classList.contains(a)) {
						headerSearch.classList.remove(a);
						headerSearchBlock.classList.remove(a);
					}
				});

				// ボタン以外をクリックした際にサイト内検索と言語メニューを閉じる
				document.addEventListener('click', (event) => {
					if (!event.target.closest('.js-changeLang, .js-changeLang-block, .js-siteSearch, .js-siteSearch-block')) {
						if(headerLanguage.classList.contains(a)) {
							headerLanguage.classList.remove(a);
							headerLanguageBlock.classList.remove(a);
						}
						if(headerSearch.classList.contains(a)) {
							headerSearch.classList.remove(a);
							headerSearchBlock.classList.remove(a);
						}
					}
				});
			}
		},
		headerMegamenu() {
			// <PC/SP>メガメニュー表示／非表示
			let megaMenu = document.querySelectorAll('.js-megaMenu-btn');
			megaMenu.forEach(ele => {
				ele.addEventListener('click', (e) => {
					document.querySelectorAll('.js-megaMenu-btn').forEach(ele2 => {
						if (ele2 !== e.currentTarget) {
							ele2.classList.remove(a);
						}
					});
					document.querySelectorAll('.js-megaMenu-block').forEach(ele2 => {
						if (ele2.getAttribute('data-name') !== e.currentTarget.getAttribute('data-name')) {
							ele2.classList.remove(a);
						}
					});

					let activeBtn = document.querySelectorAll('.js-subMenu-btn.is-active');
					let activeBlock = document.querySelectorAll('.js-subMenu-block.is-active');
					if (activeBtn.length) {
						if(activeBtn[0] !== ele) {
							activeBtn[0].classList.remove(a);
						}
					}
					if (activeBlock.length) {
						if(activeBtn[0] !== ele) {
							activeBlock[0].classList.remove(a);
						}
					}

					e.currentTarget.classList.toggle(a);
					if (e.currentTarget.getAttribute('data-name')) {
						let thisName = e.currentTarget.getAttribute('data-name');
						let thisMegaMenu = document.querySelector('.js-megaMenu-block[data-name="' + thisName + '"]');
						thisMegaMenu.classList.toggle(a);

						//  メガメニュー高さ調整
						adjustMegaMenuHeight(thisMegaMenu);
					}
				});
			});

			window.addEventListener('resize', () => {
				const activeMegamenu = document.querySelector('.js-megaMenu-block.is-active');
				if (activeMegamenu) adjustMegaMenuHeight(activeMegamenu);
			});
			
			// <PC>メガメニューの高さ調整
			const adjustMegaMenuHeight = (_target) => {
				if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.sp) {
					_target.querySelectorAll('.js-subMenu-block').forEach(sub => {
						let subHeight = sub.clientHeight;
						let closestParent = _target.querySelector('.header-megamenu-block');
						if (closestParent) {
							if (closestParent.clientHeight < subHeight) {
								closestParent.style.height = subHeight + 'px';
							}
						}
					});
				}
			};

			// <PC/SP>サブメニュー開閉
			let subMenu = document.querySelectorAll('button.js-subMenu-btn');
			subMenu.forEach(ele => {
				ele.addEventListener('click', (e) => {
					let activeBtn = document.querySelectorAll('.js-subMenu-btn.is-active');
					let activeBlock = document.querySelectorAll('.js-subMenu-block.is-active');
					if (activeBtn.length) {
						if(activeBtn[0] !== ele) {
							activeBtn[0].classList.remove(a);
						}
					}
					if (activeBlock.length) {
						if(activeBtn[0] !== ele) {
							activeBlock[0].classList.remove(a);
						}
					}
					let thisName = e.currentTarget.getAttribute('data-name');
					let thisSubMenu = document.querySelector('.js-subMenu-block[data-name="' + thisName + '"]');
					ele.classList.toggle(a);
					thisSubMenu.classList.toggle(a);

					// <SP>サブメニュー開いている間はメインメニューを固定（スクロールさせない）
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						let mainMenu = thisSubMenu.closest('.js-megaMenu-block');
						if(thisSubMenu.classList.contains(a)) {
							mainMenu.style.overflow = 'hidden';
						}
					}
				});
			});
			// <PC>クローズボタンでメガメニュー非表示
			let closeBtn = document.querySelectorAll('.js-megaMenu-close');
			closeBtn.forEach(ele => {
				ele.addEventListener('click', e => {
					menuClose();
				});
			});

			// メガメニュー内aタグ・buttonタグ選択時escキーで閉じる
			let megahead = document.querySelectorAll('.header-nav-main a,.header-nav-main button');
			megahead.forEach(ele => {
				ele.addEventListener("keydown", (e) => {
					// ESCキーでメガメニューを閉じる
					if (e.keyCode === 27) {
						menuClose();
					}
				});
			});
			// <PC/SP>サブメニュー内をクリックしたらメニュー閉じる
			let subMenuLink = document.querySelectorAll('.header-megamenu-sub a');
			subMenuLink.forEach(ele => {
				ele.addEventListener('click', () => {
					menuClose();
				});
			});
			// <PC>オーバーレイをホバーしたらメニュー非表示
			let megamenuoverlay = document.querySelectorAll('.header-megamenu-overlay');
			megamenuoverlay.forEach(ele => {
				ele.addEventListener('mouseover', (e) => {
					menuClose();
				});
			});
			// <PC>サブメニュー閉じる
			document.querySelectorAll('.header-megamenu-head').forEach(ele => {
				ele.addEventListener('mouseover', function (e) {
					let target = e.target;
					if(!target.closest('.header-megamenu-main li')) {
						let activeSub = document.querySelector('.js-subMenu-block.is-active');
						if (activeSub && !target.closest('.js-subMenu-btn, .js-subMenu-block')) {
							activeSub.classList.remove(a);
							document.querySelector('.js-subMenu-btn.is-active').classList.remove(a);
						}
					}
				});
			})

			// <SP>「戻る」ボタンでメガメニュー／サブメニュー閉じる
			let spMegaMenuClose = document.querySelectorAll('.js-megaMenu-back');
			spMegaMenuClose.forEach(ele => {
				ele.addEventListener('click', (e) => {
					let closestParent = e.target.closest('.js-megaMenu-block, .js-subMenu-block');
					if (closestParent) {
						closestParent.classList.remove(a)
						if(closestParent.classList.contains('js-subMenu-block')) {
							closestParent.closest('.js-megaMenu-block').style.overflow = 'auto';
						}
					}
				})
			});

			// <PC/SP>全て閉じる
			const menuClose = () => {
				let activeNav = document.querySelectorAll('.header-nav.is-active');
				let activeHamburger = document.querySelectorAll('.header-hamburger.is-active');
				let activeBtn = document.querySelectorAll('.js-megaMenu-btn.is-active');
				let activeBlobck = document.querySelectorAll('.js-megaMenu-block.is-active');
				let activeSubBtn = document.querySelectorAll('.js-subMenu-btn.is-active');
				let activeSubBlock = document.querySelectorAll('.js-subMenu-block.is-active');
				if (activeHamburger.length) {
					activeHamburger[0].classList.remove(a);
				}
				if (activeNav.length) {
					activeNav[0].classList.remove(a);
					activeNav[0].classList.remove(v);
				}
				if (activeBtn.length) {
					activeBtn[0].classList.remove(a);
				}
				if (activeBlobck.length) {
					activeBlobck[0].classList.remove(a);
				}
				if (activeSubBtn.length) {
					activeSubBtn[0].classList.remove(a);
				}
				if (activeSubBlock.length) {
					activeSubBlock[0].classList.remove(a);
				}
			}
		},
		siteSearch() {
			(function () {
				var s = document.createElement('script');
				s.src = '/common/js/siteSearch.js';
				document.getElementsByTagName('body')[0].appendChild(s);
			})();
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if(document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.innerText = bytesToSize(pdfElement.innerText);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li')) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		share() {
			const sharelist = document.querySelectorAll('.mod-share')
			if (sharelist.length) {
				var pageUrl = document.URL;
				var shareUrl = "";
				var sharePagetitle = encodeURIComponent(document.title);
				sharelist.forEach(elem => {
					if (elem.querySelector('._facebook')) {
						// facebook
						shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
						elem.querySelector('._facebook').setAttribute('href', shareUrl);
					}
					if (elem.querySelector('._x')) {
						// X
						shareUrl = 'https://x.com/share?url=' + pageUrl + '&text=' + sharePagetitle;
						elem.querySelector('._x').setAttribute('href', shareUrl);
					}
					if (elem.querySelector('._linkedin')) {
						// LinkedIn
						shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + pageUrl;
						elem.querySelector('._linkedin').setAttribute('href', shareUrl);
					}
				});
			}
		},
		followMenu() {
			let $menu = document.querySelector('.mod-followMenu');
			let $menuWrap = document.querySelectorAll('.mod-followMenu-wrap')[0];
			if($menu) {
				let menuPos = $menuWrap.offsetTop;
				while ($menuWrap.offsetParent) {
					$menuWrap = $menuWrap.offsetParent;
					menuPos += $menuWrap.offsetTop;
				}
				window.addEventListener('scroll', function () {
					let thisScroll = document.documentElement.scrollTop;
					if(thisScroll >= menuPos) {
						$menu.classList.add(a);
					} else {
						$menu.classList.remove(a);
					}
				})
			}
		},
		nextToggle() {
			const switchElements = document.querySelectorAll('.js-toggle');

			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', e => {
					e.currentTarget.classList.toggle(a);

					let toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle(a);
					if (toggleBlock.style.height) {
						toggleBlock.style.height = null;
						toggleBlock.style.visibility = 'hidden';
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						toggleBlock.style.visibility = 'visible';
					}
				});
			});
		},
		sideNavCurrent() {
			let sideNav = document.querySelector('.mod-sideNav-nav');
			if (sideNav) {
				let links = sideNav.querySelectorAll('a');
				if (links.length) {
					links.forEach((link) => {
						let thisHref = link.getAttribute('href');
						if (thisHref === FUNCTIONS.va.pathname || thisHref + 'index.html' === FUNCTIONS.va.pathname) {
							link.classList.add(a);

							// 下層アコーディオン内
							let parentElement = link.closest('.mod-sideNav-body-sub');
							if (parentElement) {
								parentElement.classList.add(a);
								parentElement.style.height = 'auto';
								let previousElement = parentElement.previousElementSibling;
								if (previousElement && previousElement.classList.contains('mod-sideNav-body-item')) {
									previousElement.classList.add(a);
								}
							}
							// 第4階層下層アコーディオン内
							let parentElementSub = link.closest('.mod-sideNav-body-sub-list');
							if (parentElementSub) {
								parentElementSub.classList.add(a);
								parentElementSub.style.height = 'auto';
								let previousElementSub = parentElementSub.previousElementSibling;
								if (previousElementSub && previousElementSub.classList.contains('__link')) {
									previousElementSub.classList.add(a);
								}
							}
						}
						// 企業情報／サステナ配下のみ
						if(FUNCTIONS.va.pathname.includes('/about/') || FUNCTIONS.va.pathname.includes('/sustainability/')) {
							// 4階層以下
							if (FUNCTIONS.va.pathname.split('/')[4] && thisHref.indexOf(FUNCTIONS.va.pathname.split('/')[4]) !== -1) {
								// 企業情報配下のみ
								if(FUNCTIONS.va.pathname.includes('/about/')) {
									link.classList.add(a);
								}

								let parentElement = link.closest('.mod-sideNav-body-sub');
								if (parentElement) {
									parentElement.classList.add(a);
									parentElement.style.height = 'auto';
									let previousElement = parentElement.previousElementSibling;
									if (previousElement && previousElement.classList.contains('js-toggle')) {
										previousElement.classList.add(a);
									}
								}
							}
						}
					});
				}
			}
		},
		selectBox() {
			let selectBox = document.querySelectorAll('.js-selectBox');

			if (selectBox.length) {
				selectBox.forEach(ele => {
					const list = ele.querySelector('.mod-select02-list');
					const options = ele.querySelectorAll('.mod-select02-list-option');
					const selected = ele.querySelector('.__selected');
					const input =  ele.querySelector('.js-selectBox-input');

					// フォームに送る用のinputがある場合
					if(input) {
						input.value = options[0].getAttribute('data-value');
						selected.textContent = options[0].textContent;
					}

					function slideDown(element) {
						element.style.display = 'block';
						element.style.maxHeight = element.scrollHeight + 'px';
					}
					function slideUp(element) {
						element.style.maxHeight = null;
						element.style.display = 'none';
					}

					// selectBox 要素がクリックされたとき
					// クリックイベントリスナー
					ele.addEventListener('click', (e) => {
						if (!e.target.closest('.mod-select02-list-option')) {
							if (!ele.classList.contains('is-active')) {
								selectBox.forEach(box => {
									if (box !== ele) {
										box.classList.remove('is-active');
										const listToClose = box.querySelector('.mod-select02-list');
										slideUp(listToClose);  // 他のリストを閉じる
									}
								});
								ele.classList.add('is-active');
								slideDown(list);  // 現在のリストを表示
							} else {
								ele.classList.remove('is-active');
								slideUp(list);
							}
						}
					});
					
					// selectBox以外の場所がクリックされたとき
					document.addEventListener('click', (e) => {
						if (!e.target.closest('.js-selectBox')) {
							ele.classList.remove(a);
							slideUp(list);
						}
					});

					// オプション選択時
					options.forEach(elem => {
						elem.addEventListener('click', (e) => {
							let thisTxt = elem.textContent;
							selected.textContent = thisTxt;

							if(input) {
								let thisVal = elem.getAttribute('data-value');
								input.value = thisVal;
							}


							ele.classList.remove(a);
							slideUp(list);
							options.forEach(optionElem => {
								optionElem.classList.remove('is-selected');
							});
							e.target.classList.add('is-selected');
						});
					});
				})
			}
		},
		scrollTable() {
			window.addEventListener('DOMContentLoaded', function () {
				if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
					new ScrollHint('.js-scrollable, .products-cat-tbl-base .products-cat-tblWrap:has(tbody), .mod-tblWrap', {
					suggestiveShadow: false,
						i18n: {
							scrollable: "スクロールできます"
						}
					});
				}
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.headerHamburger();
			_this.headerScroll();
			_this.headerMenu();
			_this.headerMegamenu();
			_this.siteSearch();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.share();
			_this.followMenu();
			_this.nextToggle();
			_this.sideNavCurrent();
			_this.selectBox();
			_this.scrollTable();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
